<script>
  import StepBase from "./StepBase.svelte";
  import { getAutoMpsProjectContext } from "../../AutoMpsProjectContext.js";
  import ExecutionStep from "./ExecutionStep.svelte";
  import Button from "../../../components/button/Button.svelte";

  const ctx = getAutoMpsProjectContext()

  /**
   * @type {"initial"|"dispatching"|"dispatched"|"error"}
   */
  let status = "initial"
  let executionId = null
  async function onClickExecute() {
    try {
      status = "dispatching"
      const response = await fetch(`/api/auto-mps/projects/${$ctx.projectId}/settings/execution-schedules/one-time`, {
        method: "POST",
        body: JSON.stringify({
          cronString: "",
          startAt: new Date().toISOString(),
          stopAt: new Date().toISOString(),
          schedulingParameter: "main",
          originalValues: "",
        }),
        headers: {
          "Content-Type": "application/json",
        }
      })
      const responseData = await response.json().catch(() => null)
      if (!response.ok || !responseData?.id) {
        status = "error"
      } else {
        status = "dispatched"
        executionId = responseData.id
      }
    } catch (e) {
      status = "error"
    }
  }
</script>

{#if status === "initial"}
  <StepBase>
    <div style="width: 100%; height: 100%; display: grid; place-items: center">
      <Button onClick={onClickExecute} size="large">
        計画パラメタ「main」を実行する
      </Button>
    </div>
  </StepBase>
{:else if status === "dispatching"}
  <StepBase>
    <div style="width: 100%; height: 100%; display: grid; place-items: center">
      <div>
        Asprova AutoMPS を使用して負荷の平準化を行っています...
      </div>
    </div>
  </StepBase>
{:else if status === "dispatched" && executionId}
  <ExecutionStep
    executionId={executionId}
  />
{:else if status === "error"}
  <div>実行に失敗しました。</div>
{/if}
